import { v5 as uuidv5, validate as uuidValidate } from "uuid";

import { logAndThrow } from "@/src/lib/logging/logger";

function getUuidNamespace(): string {
  const uuidNamespace = process.env.UUID_NAMESPACE;

  if (!uuidNamespace) {
    logAndThrow("UUID_NAMESPACE is required");
  }

  return uuidNamespace;
}

export function uuidV5(name: string): string {
  return uuidv5(name, getUuidNamespace());
}

export const getTaskId = (id: string) => uuidV5(`task_${id}`);

export const getFileId = (id: string) => uuidV5(`file_${id}`);

export const getTaskIdFromFileId = (fileId: string, groupId: string): string => {
  return getTaskId(groupId + fileId);
};

export const getTaskIdFromIntegrationId = (integrationId: string, groupId: string): string => {
  const fileId = getFileId(integrationId);

  return getTaskIdFromFileId(fileId, groupId);
};

export async function uuidToRandom(uuid: string): Promise<number> {
  if (!uuidValidate(uuid)) {
    throw new Error("Input must be a valid UUID string");
  }

  const encoder = new TextEncoder();
  const data = encoder.encode(uuid);
  const hashBuffer = await crypto.subtle.digest("SHA-256", data);
  const view = new DataView(hashBuffer);
  const value = view.getUint32(0, false);
  const twoTo32 = 0x100000000;

  return value / twoTo32;
}

export async function isUuidSelected(uuid: string, desiredRate: number): Promise<boolean> {
  if (desiredRate < 0 || desiredRate > 1) {
    throw new Error("desiredRate must be between 0 (inclusive) and 1 (inclusive)");
  }

  return (await uuidToRandom(uuid)) < desiredRate;
}
